import { createSelector } from 'reselect';

import { getCountryVerticals } from '@shared/selectors';
import { getShopCashPaymentMethod } from '@utils/shop';
import getShop from '@core/reducers/shop/selectors/getShop';
import { pick } from '@utils/object';
import {
  MODULE_NAME,
  DATA_SUBMODULE_NAME,
  VERTICAL_GENDER,
  VERTICAL_GENDER_ARTICLE,
  VERTICAL_GENDER_CONTRACTION,
  VERTICAL_GENDER_PRONOUM_OTHER,
} from './constants';

const getPropFromModule = (state, ...props) =>
  state.getIn([MODULE_NAME, DATA_SUBMODULE_NAME, ...props]);

const shopInfoProps = [
  'name',
  'deliveryTime',
  'minDeliveryAmount',
  'shippingAmount',
  'logo',
  'url',
  'id',
];
export const getShopInfo = createSelector(getShop, shop =>
  shop ? pick(shop, shopInfoProps) : null,
);

export const getShopId = createSelector(getShop, shop => shop?.id);

export const getShopAcceptsVouchers = createSelector(
  getShop,
  shop => shop?.acceptsVouchers,
);

export const getExitPollQuestions = createSelector(
  state => getPropFromModule(state, 'confirm', 'exitpoll'),
  exitpoll => (exitpoll && exitpoll.get('questions').toJS()) || [],
);

export const getShowExitPoll = createSelector(
  state => getPropFromModule(state, 'confirm', 'exitpoll'),
  exitpoll => (exitpoll && exitpoll.get('isShowExitPoll')) || false,
);

export const getShopMaxProductQuantity = createSelector(
  getShop,
  shop => shop?.maxProductQuantity,
);

export const getShopAcceptsPreOrder = createSelector(getShop, shop =>
  Boolean(shop?.acceptsPreOrder),
);

export const getShopCashPayment = createSelector(getShop, shop =>
  getShopCashPaymentMethod(shop),
);

export const getShopVertical = createSelector(
  getShop,
  getCountryVerticals,
  (shop, verticals) => {
    if (!shop) return null;

    const { businessType } = shop;
    const currentVertical = verticals.find(
      x => x.businessType === businessType,
    );

    if (!currentVertical) return null;

    return currentVertical;
  },
);

export const getShopType = createSelector(
  getShopVertical,
  vertical => vertical?.singular,
);

export const getShopGender = createSelector(getShopVertical, vertical =>
  vertical?.gender === VERTICAL_GENDER.MALE
    ? VERTICAL_GENDER_ARTICLE.MALE
    : VERTICAL_GENDER_ARTICLE.FEMALE,
);

export const getShopGenderArticle = createSelector(getShopVertical, vertical =>
  vertical?.gender === VERTICAL_GENDER.MALE
    ? VERTICAL_GENDER_CONTRACTION.MALE
    : VERTICAL_GENDER_CONTRACTION.FEMALE,
);

export const getShopGenderPronounOther = createSelector(
  getShopVertical,
  vertical =>
    vertical?.gender === VERTICAL_GENDER.MALE
      ? VERTICAL_GENDER_PRONOUM_OTHER.MALE
      : VERTICAL_GENDER_PRONOUM_OTHER.FEMALE,
);
